
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiRainShowersPolartwilightColour as ObiRainShowersPolartwilightColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-rain-showers-polartwilight-colour.js';
 
 
 

 
 export const ObiRainShowersPolartwilightColour = createComponent({
   react: React,
   tagName: 'obi-rain-showers-polartwilight-colour',
   elementClass: ObiRainShowersPolartwilightColourElement,
   events: {
     
   }
  });
 
 